import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as FacebookIcon } from "../../Assets/Icons/Facebook.svg";
import { ReactComponent as TwitterIcon } from "../../Assets/Icons/Twitter.svg";
import { ReactComponent as InstagramIcon } from "../../Assets/Icons/instagram.svg";

import { ReactComponent as BudgItIcon } from "../../Assets/Icons/budget_it-icon.svg";
import { ReactComponent as CodeLogoIcon } from "../../Assets/Icons/code_logo-icon.svg";
import { ReactComponent as GlobalIntegrityIcon } from "../../Assets/Icons/global-integrity-icon.svg";
import { useMediaQuery } from 'react-responsive';
import getSubMenu from './subMenu';



const logoMenu = [
  { url: "https://yourbudgit.com/", logo: <BudgItIcon /> },
  { url: "https://www.connecteddevelopment.org/", logo: <CodeLogoIcon /> },
  { url: "https://www.globalintegrity.org/", logo: <GlobalIntegrityIcon /> },
];
const socialMedia = [
  { icon: <TwitterIcon />, url: "https://twitter.com/BudgITng" },
  { icon: <FacebookIcon />, url: "https://web.facebook.com/budgitng" },
  { icon: <InstagramIcon />, url: "https://www.instagram.com/budgitng/" },
];
const Footer = ({
  appNav
}) => {
  const isTablet = useMediaQuery({ query: "(max-width: 768px)" });

  const subMenu = getSubMenu(appNav)
  return (
    <footer className="bg-chestNut m-0 text-xs font-ubuntu">
      <div className="py-12 layout__wrapper lg:flex">
        <ul className="w-full flex items-center flex-col capitalize text-white text-xs leading-18 mb-10 md:flex-row md:justify-center md:mb-8 font-medium lg:mb-0 lg:justify-start">
          {subMenu?.map((menu) => {
            if (menu?.check && !menu?.check()) {
              return null;
            }
            return (
              <li className="mb-42 last:mb-0 md:mb-0 md:mr-9 md:last:mr-0">
                <Link to={menu?.path}>
                  <span>{menu?.title}</span>
                </Link>
              </li>
            );
          })}
          <li className="mb-42 last:mb-0 md:mb-0 md:mr-9 md:last:mr-0">
            <a target="_blank" rel="noreferrer" href="https://airtable.com/shr1SjJBhwOxvcmXd/tblGzlVNLmlI3vQ59">
            <span>COVID-19 data</span>
            </a>
          </li>
        </ul>
        <ul className="flex items-center flex-col mb-10 md:flex-row md:justify-center md:mb-0">
          {logoMenu?.map((menu) => (
            <li className="mb-4 last:mb-0 md:mb-0 md:mr-6 md:last:mr-0">
              <a href={menu?.url} target="_blank" rel="noreferrer">
                {menu?.logo}{" "}
              </a>
            </li>
          ))}
        </ul>
        {isTablet && (
          <ul className="flex justify-center md:hidden text-white ">
            {socialMedia?.map((menu) => (
              <li className="mb-4 last:mb-0 mr-4 last:mr-0">
                <a href={menu?.url} target="_blank" rel="noreferrer">
                  {menu?.icon}{" "}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="border-t border-white text-white">
        <div className="layout__wrapper flex items-center justify-center py-2 text-sm leading-5 md:justify-between">
          <div className="text-sm">
            ©{new Date().getFullYear()} - CTAP | All right reserved
          </div>
          {!isTablet && (
            <ul className="md:flex justify-center hidden text-white">
              {socialMedia?.map((menu) => (
                <li className="mb-4 last:mb-0 mr-4 last:mr-0 md:mb-0">
                  <a href={menu?.url} target="_blank" rel="noreferrer">
                    {menu?.icon}{" "}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
